<template>
  <div>
    <hero-slider v-if="slides.length > 0" :items="slides"></hero-slider>
    <categories-wall :items="categoryWallItems"></categories-wall>
    <popular-products v-if="trends.length > 0" :items="trends">
      <template #title>Сейчас в тренде</template>
    </popular-products>
    <last-news></last-news>
  </div>
</template>

<script>
import HeroSlider from '../../components/modules/HeroSlider/HeroSlider'
import CategoriesWall from '../../components/modules/CategoriesWall/CategoriesWall'
import PopularProducts from '../../components/modules/ProductsCarousel/ProductsCarousel'
import LastNews from '../../components/modules/News/NewsModule'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  name: 'HomePage',
  title: 'Главная BrewDrop',
  pageClass: 'home-page',
  components: {
    HeroSlider,
    CategoriesWall,
    PopularProducts,
    LastNews
  },
  computed: {
    ...mapState('blocks', ['slides', 'categoryWallItems', 'trends'])
  },
  methods: {
    ...mapActions('blocks', ['getSlider', 'getTrends', 'getCategoryWall']),
    ...mapMutations('blocks', ['setSlides']),
    prepare () {
      this.getSlider()
      this.getTrends()
      this.getCategoryWall()
    }
  },
  created () {
    this.prepare()
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>

</style>
